import { render } from "./beian.vue?vue&type=template&id=0afc735c&scoped=true"
import script from "./beian.vue?vue&type=script&lang=js"
export * from "./beian.vue?vue&type=script&lang=js"

import "./beian.vue?vue&type=style&index=0&id=0afc735c&lang=less&scoped=true"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afc735c"]])

export default __exports__